import actions from './actions'
import crudReducers from '../../crud/reducers'

const dataPropName = 'activity'

const initState = {
  list: null,
  listLoaded: false,
  loading: false,
  loaded: false,
  error: false,
  modalActive: false,
  activity: {}
}

const reducers = crudReducers(actions, dataPropName, initState)

export default reducers
